import { useEffect } from "react";
import { useShallow } from "zustand/shallow";
import { usePostHog } from "posthog-js/react";

import { useBoundStore } from "@/app/store";
import { supabase } from "@/services/supabase/client";

export function useAuth() {
  const posthog = usePostHog();
  const { setUser } = useBoundStore(useShallow((state) => ({ setUser: state.user.set })));

  // Check if the user is authenticated by looking into local storage session
  useEffect(() => {
    (async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      setUser({
        isAuthenticated: Boolean(session),
        isAnonymous: Boolean(session?.user?.is_anonymous),
        id: session?.user.id,
        loading: false,
      });
    })();
  }, [setUser]);

  /**
   * Listen to auth state changes
   */
  useEffect(() => {
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, updatedSession) => {
      if (updatedSession?.user) {
        posthog.identify(updatedSession.user.id);
      }

      setUser({
        isAuthenticated: Boolean(updatedSession),
        isAnonymous: Boolean(updatedSession?.user?.is_anonymous),
        id: updatedSession?.user.id,
        loading: false,
      });
    });

    return () => {
      subscription?.unsubscribe();
    };
  }, [posthog, setUser]);

  return null;
}
